import { ENDPOINT } from "../../network/ENDPOINT";
import { callGetApiToServer, callApiToServer } from "../callApi";

function resolveToken(authToken) {
  return (
    authToken ||
    localStorage.getItem("token") ||
    localStorage.getItem("admin_token") ||
    ""
  );
}

function buildHeaders(authToken) {
  const token = resolveToken(authToken);
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "Bearer " + token,
  };
}

/**
 * Fetch query QPS and latency performance metrics from backend
 */
export async function getSystemMetricsAPI(
  authToken,
  { sort = "requests", limit = 100, minRequests = 0 } = {}
) {
  try {
    const headers = buildHeaders(authToken);
    const query = `?sort=${encodeURIComponent(sort)}&limit=${encodeURIComponent(
      limit
    )}&min_requests=${encodeURIComponent(minRequests)}&html=false`;
    const endUrl = `${ENDPOINT.get_system_metrics}${query}`;
    return await callGetApiToServer(headers, "GET", endUrl);
  } catch (err) {
    throw err;
  }
}

/**
 * Reset in-memory query performance metrics
 */
export async function resetSystemMetricsAPI(authToken) {
  try {
    const headers = buildHeaders(authToken);
    const body = JSON.stringify({});
    return await callApiToServer(
      body,
      headers,
      "POST",
      ENDPOINT.reset_system_metrics
    );
  } catch (err) {
    throw err;
  }
}
